import React from 'react';
import { bool, func, oneOf, string } from 'prop-types';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import useFormId from '../../hooks/useFormId';

import classes from './DataTypeSelect.module.css';

export const Types = {
    boolean: 'Boolean',
    float:   'Float',
    integer: 'Integer',
    text:    'Text'
};

const DataTypeSelect = ({ className, name, onChange, showLabel, value }) => {
    const formId = useFormId(name);
    let label = null;
    if (showLabel) {
        label = (
            <InputLabel
                className={classes.label}
                htmlFor={formId}
            >
                Data Type
            </InputLabel>
        );
    }

    return (
        <React.Fragment>
            {label}
            <Select
                className={className}
                id={formId}
                inputProps={{
                    classes: {
                        root: classes.input
                    }
                }}
                MenuProps={{
                    MenuListProps: {
                        className: classes.select
                    }
                }}
                name={name}
                onChange={onChange}
                value={value || ''}
            >
                {Object.entries(Types).map(([value, label]) => (
                    <MenuItem key={value} value={value}>{label}</MenuItem>
                ))}
            </Select>
        </React.Fragment>
    );
};

DataTypeSelect.defaultProps = {
    className: '',
    name:      'dataType',
    onChange:  () => {},
    showLabel: true
};

DataTypeSelect.propTypes = {
    className: string,
    name:      string,
    onChange:  func.isRequired,
    showLabel: bool,
    value:     oneOf(['', ...Object.keys(Types)])
};

export default DataTypeSelect;
